export default __webpack_public_path__ + "static/media/card_track_co.da40475e.webp";